import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { Input, Form, Message } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';
import _isString from 'lodash/isString';

import useMessages from 'hooks/useMessages';

import FileSourceFilter from '../../../../../../core/FileManagement/components/FileSourceFilter';

import './SearchBar.scss';

const propTypes = {
  handleSearchChange: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
  isSearching: PropTypes.bool.isRequired,
  setError: PropTypes.func.isRequired,
  error: PropTypes.string,
  sourceFilter: PropTypes.string.isRequired,
  onSourceFilterChange: PropTypes.func.isRequired,
};

const defaultProps = {
  error: null,
};

export default function SearchBar({
  handleSearchChange,
  searchValue,
  isSearching,
  setError,
  error,
  onSearchFocus,
  onSearchBlur,
  sourceFilter,
  onSourceFilterChange,
}) {
  const { message, clearMessage, showError } = useMessages({
    initial: error,
    autoHideDelay: 0,
  });

  useEffect(() => {
    if (error) {
      showError(error);
    }
  }, [message]);

  let messagesMap = error || {};
  if (_isString(error)) {
    messagesMap = { [error]: [] };
  }

  function removeErrorMessage() {
    clearMessage();

    if (setError) {
      setError('');
    }
  }

  function errorMessageToDisplay(errorKey) {
    const errorMessage = messagesMap[errorKey];
    return (
      <Message
        key={errorKey}
        negative
        onDismiss={removeErrorMessage}
        header={errorKey}
        list={_isEmpty(errorMessage) ? null : errorMessage}
      />
    );
  }

  return (
    <>
      <Form.Group unstackable className="file-search-bar">
        <Form.Field width={4}>
          <FileSourceFilter filter={sourceFilter} onFilterChange={onSourceFilterChange} />
        </Form.Field>
        <Form.Field width={12}>
          <Input
            placeholder="Search"
            icon="search"
            value={searchValue}
            onChange={handleSearchChange}
            className="business-file-search-bar"
            loading={isSearching}
            onFocus={onSearchFocus}
            onBlur={onSearchBlur}
          />
        </Form.Field>
      </Form.Group>

      {Object.keys(messagesMap).map((errorTitle) => errorMessageToDisplay(errorTitle))}
    </>
  );
}

SearchBar.propTypes = propTypes;
SearchBar.defaultProps = defaultProps;
